import { createStore, combineReducers, applyMiddleware } from 'redux';

import { reducer as planReducer } from './slices/plans';
import { reducer as AlertReducer } from './slices/alert';
import { reducer as annualPlanV2Reducer } from './slices/annualPlanV2';
import { reducer as focusesReducer } from './slices/focuses';
import { reducer as objectivesReducer } from './slices/objectives';
import { reducer as requirementsReducer } from './slices/requirements';
import { reducer as ActivitiesReducer } from './slices/activities';
import { reducer as checklistsReducer } from './slices/checklists';
import { reducer as accidentAnalysisReducer } from './slices/accidentAnalysis';
import { reducer as selfAssessmentResultsReducer } from './slices/selfAssessmentResults';
import { DataSourceService } from './types/state';

interface Services {
  dataSource: DataSourceService;
}

type AppAction = { type: string; payload?: unknown };
type ThunkAction = (
  dispatch: (action: AppAction | ThunkAction) => void,
  getState: () => unknown,
  extra: { services: Services },
) => void;

export default function _createStore(services: Services) {
  const customThunk =
    (store: { dispatch: (action: AppAction | ThunkAction) => void; getState: () => unknown }) =>
    (next: (action: unknown) => unknown) =>
    (action: unknown) => {
      if (typeof action === 'function') {
        return (action as ThunkAction)(store.dispatch, store.getState, {
          services,
        });
      }
      return next(action);
    };

  return createStore(
    combineReducers({
      plans: planReducer,
      annualPlanV2: annualPlanV2Reducer,
      focuses: focusesReducer,
      objectives: objectivesReducer,
      requirements: requirementsReducer,
      activities: ActivitiesReducer,
      checklists: checklistsReducer,
      alert: AlertReducer,
      accidentAnalysis: accidentAnalysisReducer,
      selfAssessmentResults: selfAssessmentResultsReducer,
    }),
    applyMiddleware(customThunk),
  );
}
